/* Reviews · nextdev-reviews

   The script of reviews-section/index.html, line for line. It binds every
   [data-nextdev-reviews] on the page once, and again when the theme editor
   reloads the section. */

// ---- the reviews section ----
// The filters and show more read the cards themselves, so the markup is
// the only source of truth and the theme can render as many as it likes.
(function () {
  // how many cards one page holds
  var PER_PAGE = 5;

  function setup(root) {
    if (root.dataset.nextdevReviewsInit) return;
    root.dataset.nextdevReviewsInit = '1';

    var list = root.querySelector('[data-nextdev-reviews-list]');
    var empty = root.querySelector('[data-nextdev-reviews-empty]');
    var pager = root.querySelector('[data-nextdev-reviews-pager]');
    if (!list) return;

    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-nextdev-reviews-card]'));
    if (!cards.length) return;

    var page = 1;

    // a review's videos always come before its photos, in the card and so
    // in the pop-up, which reads the card's order
    cards.forEach(function (card) {
      var proof = card.querySelector('.nextdev--reviews__proof');
      if (!proof) return;
      var videos = proof.querySelectorAll('[data-nextdev-reviews-video]');
      for (var i = videos.length - 1; i >= 0; i--) proof.insertBefore(videos[i], proof.firstElementChild);
    });

    // ---- the overview: the average, how the stars fall and how many would
    // recommend, all read off the cards, so it never says what they do not
    var overview = root.querySelector('[data-nextdev-reviews-overview]');
    if (overview) {
      var tally = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      var sum = 0;
      var rated = 0;
      var recommend = 0;
      cards.forEach(function (card) {
        var stars = card.querySelector('.nextdev--reviews__stars');
        var value = stars ? parseInt(stars.getAttribute('aria-label'), 10) : NaN;
        if (value >= 1 && value <= 5) {
          tally[value] += 1;
          sum += value;
          rated += 1;
        }
        if (card.querySelector('.nextdev--reviews__badge--recommend')) recommend += 1;
      });
      var average = rated ? sum / rated : 0;
      var said = average.toFixed(1);
      var averageLine = overview.querySelector('[data-nextdev-reviews-average]');
      var averageStars = overview.querySelector('[data-nextdev-reviews-average-stars]');
      var based = overview.querySelector('[data-nextdev-reviews-based]');
      var percent = overview.querySelector('[data-nextdev-reviews-recommend]');
      if (averageLine) averageLine.textContent = said;
      if (averageStars) {
        averageStars.setAttribute('aria-label', said + ' out of 5 stars');
        averageStars.style.setProperty('--nextdev-reviews-average', (average / 5 * 100) + '%');
      }
      if (based) based.textContent = 'Based on ' + rated + (rated === 1 ? ' review' : ' reviews');
      if (percent) percent.textContent = (cards.length ? Math.round(recommend / cards.length * 100) : 0) + '%';
      overview.querySelectorAll('[data-nextdev-reviews-bar]').forEach(function (bar) {
        var count = tally[bar.getAttribute('data-nextdev-reviews-bar')] || 0;
        var shown = bar.querySelector('[data-nextdev-reviews-bar-count]');
        if (shown) shown.textContent = count;
        bar.style.setProperty('--nextdev-reviews-share', (rated ? count / rated * 100 : 0) + '%');
      });
    }

    function valueOf(card, name) {
      return (card.getAttribute('data-nextdev-reviews-' + name + '-value') || '').trim();
    }

    // ---- the filters: a press on "All breeds" or "All sizes" opens that
    // field's options as pills under the row, and closes the other's. A pill
    // picks its value, and a picked one carries an X that takes it off again,
    // as does the X the button then carries. Several of each can be picked:
    // a review shows when it is any of the breeds and any of the sizes.
    var chosen = {};
    var chipsBox = root.querySelector('[data-nextdev-reviews-chips]');
    var selects = [];

    function filterValue(name) {
      return chosen[name] || [];
    }

    function cross(className) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 12 12');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.6');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('class', className);
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M2 2l8 8M10 2l-8 8');
      svg.appendChild(path);
      return svg;
    }

    function openSelect(which) {
      selects.forEach(function (each) {
        var on = each === which;
        each.group.hidden = !on;
        each.button.setAttribute('aria-expanded', on ? 'true' : 'false');
        each.button.classList.toggle('nextdev--reviews__select-button--open', on);
      });
    }

    if (chipsBox) {
      chipsBox.textContent = '';
      root.querySelectorAll('[data-nextdev-reviews-select]').forEach(function (node, index) {
        var field = node.getAttribute('data-nextdev-reviews-select');
        var button = node.querySelector('[data-nextdev-reviews-select-button]');
        var label = node.querySelector('[data-nextdev-reviews-select-value]');
        var clear = node.querySelector('[data-nextdev-reviews-select-clear]');
        if (!field || !button || !label) return;
        var all = node.getAttribute('data-nextdev-reviews-all') || 'All';

        var values = [];
        cards.forEach(function (card) {
          var value = valueOf(card, field);
          if (value && values.indexOf(value) < 0) values.push(value);
        });
        values.sort(function (a, b) { return a.localeCompare(b); });
        // nothing to pick: no review names one, so the field is left out
        if (!values.length) {
          node.hidden = true;
          return;
        }

        var group = document.createElement('div');
        group.className = 'nextdev--reviews__chips-group';
        group.id = 'nextdev-reviews-chips-' + field + '-' + index + '-' + (root.id || 'section');
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', all);
        group.hidden = true;
        button.setAttribute('aria-controls', group.id);

        var entry = { node: node, field: field, button: button, label: label, clear: clear, all: all, group: group, chips: [] };

        values.forEach(function (value) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'nextdev--reviews__chip';
          var text = (field === 'size' ? 'Size: ' : '') + value;
          chip.appendChild(document.createTextNode(text));
          chip.appendChild(cross('nextdev--reviews__chip-cross'));
          chip.addEventListener('click', function () {
            var picked = filterValue(field);
            chosen[field] = picked.indexOf(value) < 0
              ? picked.concat(value)
              : picked.filter(function (each) { return each !== value; });
            reset();
          });
          group.appendChild(chip);
          entry.chips.push({ chip: chip, value: value, text: text });
        });

        button.addEventListener('click', function () {
          openSelect(group.hidden ? entry : null);
        });
        if (clear) {
          clear.addEventListener('click', function () {
            chosen[field] = [];
            reset();
            button.focus();
          });
        }

        chipsBox.appendChild(group);
        selects.push(entry);
      });
      chipsBox.hidden = !selects.length;
    }

    // escape puts the open pills away and hands the focus back to its button
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      selects.forEach(function (each) {
        if (each.group.hidden) return;
        openSelect(null);
        each.button.focus();
      });
    });

    function markChips() {
      selects.forEach(function (each) {
        var current = filterValue(each.field);
        // the button keeps its name and says what is picked after it: the one
        // value, or how many once there are several
        each.label.textContent = !current.length ? each.all
          : each.all + ': ' + (current.length === 1 ? current[0] : current.length + ' selected');
        each.node.classList.toggle('nextdev--reviews__select--chosen', current.length > 0);
        if (each.clear) {
          each.clear.hidden = !current.length;
          each.clear.setAttribute('aria-label', 'Remove every ' + (each.field === 'size' ? 'size' : 'breed') + ' filter');
        }
        each.chips.forEach(function (one) {
          var on = current.indexOf(one.value) >= 0;
          one.chip.classList.toggle('nextdev--reviews__chip--on', on);
          one.chip.setAttribute('aria-pressed', on ? 'true' : 'false');
          one.chip.setAttribute('aria-label', on ? 'Remove filter: ' + one.text : 'Filter by ' + one.text);
        });
      });
    }

    function matching() {
      // any of the breeds picked, and any of the sizes picked
      var breed = filterValue('breed');
      var size = filterValue('size');
      return cards.filter(function (card) {
        if (breed.length && breed.indexOf(valueOf(card, 'breed')) < 0) return false;
        if (size.length && size.indexOf(valueOf(card, 'size')) < 0) return false;
        return true;
      });
    }

    // Show more: the reviews come in fives, and the button under them adds
    // the next five to what is already there, so nothing the visitor has
    // read moves. Its label says how many are left.
    function render() {
      var shown = matching();
      markChips();
      var pages = Math.max(1, Math.ceil(shown.length / PER_PAGE));
      if (page > pages) page = pages;
      var last = Math.min(page * PER_PAGE, shown.length);

      cards.forEach(function (card) {
        card.classList.add('nextdev--reviews__card--hidden');
      });
      shown.slice(0, last).forEach(function (card) {
        card.classList.remove('nextdev--reviews__card--hidden');
      });

      if (empty) empty.hidden = shown.length > 0;

      if (pager) {
        pager.textContent = '';
        if (last < shown.length) {
          var more = document.createElement('button');
          more.type = 'button';
          more.className = 'nextdev--reviews__more';
          more.textContent = 'Show more reviews';
          more.addEventListener('click', function () {
            var next = shown[last];
            page += 1;
            render();
            // the focus goes to the first review it brought in, so a keyboard
            // carries on reading where the new ones start
            if (next) {
              next.setAttribute('tabindex', '-1');
              next.focus({ preventScroll: true });
            }
          });
          pager.appendChild(more);
        }
      }
    }

    function reset() {
      page = 1;
      render();
    }

    // ---- the pop-up ----
    // A photo or a video opens large beside its review, the way a post opens
    // in the apps. The arrows on the photo step through that review's own
    // photos and videos; the ones at the edge of the screen step to the
    // review before or after it, among those the filters show that carry a
    // photo or a video. The video file is only fetched once it is asked for.
    var lightbox = root.querySelector('[data-nextdev-reviews-lightbox]');
    if (lightbox) {
      var stage = lightbox.querySelector('[data-nextdev-reviews-lightbox-stage]');
      var caption = lightbox.querySelector('[data-nextdev-reviews-lightbox-caption]');
      var infoBox = lightbox.querySelector('[data-nextdev-reviews-lightbox-info]');
      var closeButton = lightbox.querySelector('[data-nextdev-reviews-lightbox-close]');
      var prevReview = lightbox.querySelector('[data-nextdev-reviews-lightbox-prev]');
      var nextReview = lightbox.querySelector('[data-nextdev-reviews-lightbox-next]');
      var prevMedia = lightbox.querySelector('[data-nextdev-reviews-lightbox-media-prev]');
      var nextMedia = lightbox.querySelector('[data-nextdev-reviews-lightbox-media-next]');
      var dotsBox = lightbox.querySelector('[data-nextdev-reviews-lightbox-dots]');
      var progress = lightbox.querySelector('[data-nextdev-reviews-lightbox-progress]');
      var watch = lightbox.querySelector('[data-nextdev-reviews-lightbox-watch]');
      var watchLabel = lightbox.querySelector('[data-nextdev-reviews-lightbox-watch-label]');
      var mute = lightbox.querySelector('[data-nextdev-reviews-lightbox-mute]');
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // once the sound is on it stays on for the next video in the pop-up
      var withSound = false;
      var player = null;
      var reviews = [];
      var reviewAt = 0;
      var group = [];
      var dotsGroup = null;
      var at = 0;
      var opener = null;
      var panel = lightbox.querySelector('.nextdev--reviews__lightbox-panel');
      var POS = { '-2': 'm2', '-1': 'm1', '0': '0', '1': '1', '2': '2' };
      var ghosts = [];
      var sliding = false;

      // nothing a theme wraps the section in can clip it out there
      document.body.appendChild(lightbox);

      function mediaOf(card) {
        return Array.prototype.slice.call(card.querySelectorAll('[data-nextdev-reviews-media]'));
      }

      // photos from customers that belong to no review: the pop-up steps
      // through them a customer at a time, the way it does the reviews
      var customers = Array.prototype.slice.call(root.querySelectorAll('[data-nextdev-reviews-customer]'));

      function nameOf(i) {
        return group[i] && group[i].getAttribute('data-nextdev-reviews-video') ? 'Video' : 'Photo';
      }

      // a line per photo or video of this review, the open one longer
      function drawDots() {
        if (!dotsBox) return;
        // within one review the lines are kept and only marked, so the open
        // one grows and the last one shrinks rather than being drawn again
        if (dotsGroup === group && dotsBox.children.length === group.length) {
          Array.prototype.forEach.call(dotsBox.children, function (dot, i) {
            dot.classList.toggle('nextdev--reviews__lightbox-dot--on', i === at);
            dot.setAttribute('aria-current', i === at ? 'true' : 'false');
          });
          return;
        }
        dotsGroup = group;
        dotsBox.textContent = '';
        dotsBox.hidden = group.length < 2;
        if (group.length < 2) return;
        group.forEach(function (each, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'nextdev--reviews__lightbox-dot' + (i === at ? ' nextdev--reviews__lightbox-dot--on' : '');
          dot.setAttribute('aria-label', nameOf(i) + ' ' + (i + 1) + ' of ' + group.length);
          dot.setAttribute('aria-current', i === at ? 'true' : 'false');
          dot.addEventListener('click', function () {
            at = i;
            show();
            dotsBox.children[i] && dotsBox.children[i].focus();
          });
          dotsBox.appendChild(dot);
        });
      }

      function markWatch() {
        if (!watch || !player) return;
        var playing = !player.paused;
        watch.classList.toggle('nextdev--reviews__lightbox-watch--playing', playing);
        watch.setAttribute('aria-pressed', playing ? 'true' : 'false');
        if (watchLabel) watchLabel.textContent = playing ? 'Pause video' : 'Watch video';
      }

      function markMute() {
        if (!mute || !player) return;
        var on = !player.muted;
        mute.classList.toggle('nextdev--reviews__lightbox-mute--on', on);
        mute.setAttribute('aria-pressed', on ? 'true' : 'false');
        mute.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
      }

      function showControls() {
        var on = !!player;
        if (watch) watch.hidden = !on;
        if (mute) mute.hidden = !on;
        if (progress) {
          progress.hidden = !on;
          progress.classList.remove('nextdev--reviews__lightbox-progress--on');
          progress.style.setProperty('--nextdev-reviews-progress', '0%');
        }
        markWatch();
        markMute();
      }

      function play() {
        if (!player) return;
        var current = player;
        current.muted = !withSound;
        markMute();
        var started = current.play();
        if (started && typeof started.then === 'function') {
          started.catch(function () {
            // the browser refused the sound without a tap of its own: play muted
            if (current === player && !current.muted) {
              withSound = false;
              current.muted = true;
              markMute();
              current.play().catch(function () {});
            }
          });
        }
      }

      function toggle() {
        if (!player) return;
        if (player.paused) {
          play();
        } else {
          player.pause();
        }
      }

      // The video plays without sound on its own as it opens, unless the
      // visitor asks for less motion; the file is only fetched once it is shown.
      function makePlayer(src, image) {
        var el = document.createElement('video');
        el.className = 'nextdev--reviews__lightbox-video';
        el.setAttribute('preload', 'none');
        el.setAttribute('muted', '');
        el.setAttribute('playsinline', '');
        el.setAttribute('webkit-playsinline', '');
        el.setAttribute('disablepictureinpicture', '');
        // iOS needs these set as properties, not only as attributes
        el.muted = true;
        el.defaultMuted = true;
        el.playsInline = true;
        if (image && image.tagName === 'IMG') el.poster = image.getAttribute('src');
        el.src = src;
        el.addEventListener('timeupdate', function () {
          if (!progress || el !== player) return;
          var along = el.duration ? el.currentTime / el.duration : 0;
          progress.style.setProperty('--nextdev-reviews-progress', (along * 100).toFixed(2) + '%');
          progress.classList.toggle('nextdev--reviews__lightbox-progress--on', along > 0);
        });
        el.addEventListener('play', markWatch);
        el.addEventListener('pause', markWatch);
        el.addEventListener('volumechange', markMute);
        // at the end it goes back to the start, the way the gallery's does
        el.addEventListener('ended', function () {
          el.currentTime = 0;
          markWatch();
        });
        el.addEventListener('click', toggle);
        if (!reduced) window.setTimeout(function () { if (el === player) play(); }, 0);
        return el;
      }

      function show() {
        var button = group[at];
        var image = button.querySelector('.nextdev--reviews__photo');
        var video = button.getAttribute('data-nextdev-reviews-video');
        var card = reviews[reviewAt];

        stage.textContent = '';
        player = null;
        if (video) {
          player = makePlayer(video, image);
          stage.appendChild(player);
        } else if (image) {
          var large = document.createElement('img');
          large.src = button.getAttribute('data-nextdev-reviews-full') || image.getAttribute('src');
          large.alt = image.getAttribute('alt') || '';
          stage.appendChild(large);
        }

        var several = group.length > 1;
        // the count is said, not shown: the lines on the photo show it
        caption.textContent = several ? nameOf(at) + ' ' + (at + 1) + ' of ' + group.length : '';
        if (prevMedia) {
          prevMedia.hidden = !several;
          prevMedia.disabled = at === 0;
        }
        if (nextMedia) {
          nextMedia.hidden = !several;
          nextMedia.disabled = at === group.length - 1;
        }
        drawDots();
        showControls();
        if (prevReview) prevReview.hidden = reviews.length < 2;
        if (nextReview) nextReview.hidden = reviews.length < 2;
        // a button that has just been hidden takes the focus with it, and the
        // keys and the tab order would leave the pop-up; the close takes it
        var focused = document.activeElement;
        if (!lightbox.hidden && (!lightbox.contains(focused) || focused.hidden || focused.disabled)) closeButton.focus();

        if (infoBox) {
          fillInfo(infoBox, card);
          infoBox.scrollTop = 0;
        }
      }

      // the review beside the photo is a copy of what the card already
      // says, the reply from customer care included
      function fillInfo(box, card) {
        box.textContent = '';
        if (card) {
          ['.nextdev--reviews__info', '.nextdev--reviews__main', '.nextdev--reviews__foot'].forEach(function (part) {
            var found = card.querySelector(part);
            if (found) box.appendChild(found.cloneNode(true));
          });
        }
        box.hidden = !box.firstChild;
      }

      // ---- the carousel: the review before and the one after stand either
      // side as a picture of themselves, and slide in on a change
      function place(el, pos, instant) {
        Object.keys(POS).forEach(function (key) {
          el.classList.remove('nextdev--reviews__lightbox-panel--pos-' + POS[key]);
        });
        el.classList.toggle('nextdev--reviews__lightbox-panel--instant', !!instant);
        el.classList.add('nextdev--reviews__lightbox-panel--pos-' + POS[pos]);
        el.nextdevReviewsPos = pos;
        if (instant) {
          void el.offsetWidth;
          el.classList.remove('nextdev--reviews__lightbox-panel--instant');
        }
      }

      function ghostOf(index, last) {
        var card = reviews[(index + reviews.length) % reviews.length];
        var items = mediaOf(card);
        var button = items[last ? items.length - 1 : 0];
        var ghost = document.createElement('div');
        ghost.className = 'nextdev--reviews__lightbox-panel nextdev--reviews__lightbox-panel--ghost';
        ghost.setAttribute('aria-hidden', 'true');
        var media = document.createElement('div');
        media.className = 'nextdev--reviews__lightbox-media';
        var holder = document.createElement('div');
        holder.className = 'nextdev--reviews__lightbox-stage';
        var image = button && button.querySelector('.nextdev--reviews__photo');
        if (image && image.tagName !== 'IMG') {
          // a video with no picture of its own shows its first frame
          var frame = image.cloneNode(false);
          frame.removeAttribute('class');
          frame.muted = true;
          holder.appendChild(frame);
        } else if (image) {
          var picture = document.createElement('img');
          picture.src = (!button.getAttribute('data-nextdev-reviews-video') && button.getAttribute('data-nextdev-reviews-full')) || image.getAttribute('src');
          picture.alt = '';
          holder.appendChild(picture);
        }
        media.appendChild(holder);
        var info = document.createElement('div');
        info.className = 'nextdev--reviews__lightbox-info';
        fillInfo(info, card);
        // what is inside cannot be reached; the ghost itself takes the tap
        media.inert = true;
        info.inert = true;
        ghost.appendChild(media);
        ghost.appendChild(info);
        panel.parentNode.insertBefore(ghost, panel);
        return ghost;
      }

      function clearGhosts() {
        ghosts.forEach(function (ghost) { ghost.remove(); });
        ghosts = [];
      }

      // the two either side of the open review, put there with no movement
      function setGhosts() {
        clearGhosts();
        place(panel, 0, true);
        if (reviews.length < 2) return;
        [-1, 1].forEach(function (pos) {
          var ghost = ghostOf(reviewAt + pos);
          place(ghost, pos, true);
          ghosts.push(ghost);
        });
      }

      function toReview(index, last) {
        var delta = index - reviewAt;
        var target = (index + reviews.length) % reviews.length;
        if (sliding) return;
        if (reduced || reviews.length < 2 || Math.abs(delta) !== 1) {
          reviewAt = target;
          group = mediaOf(reviews[reviewAt]);
          at = last ? group.length - 1 : 0;
          show();
          setGhosts();
          return;
        }
        sliding = true;
        if (player) player.pause();
        // the one beyond comes in from the far side as the others move along
        var coming = ghostOf(reviewAt + 2 * delta, false);
        place(coming, 2 * delta, true);
        ghosts.push(coming);
        void coming.offsetWidth;
        ghosts.forEach(function (ghost) { place(ghost, ghost.nextdevReviewsPos - delta); });
        place(panel, -delta);
        window.setTimeout(function () {
          reviewAt = target;
          group = mediaOf(reviews[reviewAt]);
          at = last ? group.length - 1 : 0;
          show();
          setGhosts();
          sliding = false;
        }, 460);
      }

      // the photo arrows stop at the first and the last
      function stepMedia(delta) {
        var next = Math.max(0, Math.min(group.length - 1, at + delta));
        if (next === at) return;
        at = next;
        show();
      }

      // the keyboard reads every photo in a row: past the last one of a
      // review it carries on into the next review, and back the same way
      function stepAll(delta) {
        var next = at + delta;
        if (next >= 0 && next < group.length) {
          at = next;
          show();
        } else if (reviews.length > 1) {
          toReview(reviewAt + delta, delta < 0);
        }
      }

      // the focus goes back to whatever opened it: a card's photo, or a
      // photo in the overview's row
      function openLightbox(button, from) {
        var card = button.closest('[data-nextdev-reviews-card], [data-nextdev-reviews-customer]');
        var own = card.hasAttribute('data-nextdev-reviews-customer');
        reviews = (own ? customers : matching()).filter(function (each) { return mediaOf(each).length; });
        if (prevReview) prevReview.setAttribute('aria-label', own ? 'Previous customer' : 'Previous review');
        if (nextReview) nextReview.setAttribute('aria-label', own ? 'Next customer' : 'Next review');
        lightbox.setAttribute('aria-label', own ? 'Photos from our customers' : 'A review with its photos and videos');
        reviewAt = reviews.indexOf(card);
        if (reviewAt < 0) {
          reviews = [card];
          reviewAt = 0;
        }
        group = mediaOf(card);
        at = group.indexOf(button);
        if (at < 0) at = 0;
        opener = from || button;
        lightbox.hidden = false;
        document.body.classList.add('nextdev--reviews__body--locked');
        show();
        setGhosts();
        closeButton.focus();
      }

      function closeLightbox() {
        if (lightbox.hidden) return;
        if (player) player.pause();
        player = null;
        stage.textContent = '';
        if (infoBox) infoBox.textContent = '';
        clearGhosts();
        lightbox.hidden = true;
        document.body.classList.remove('nextdev--reviews__body--locked');
        if (opener) opener.focus();
        opener = null;
      }

      list.addEventListener('click', function (event) {
        var button = event.target.closest('[data-nextdev-reviews-media]');
        if (button) openLightbox(button);
      });

      // every photo and video from the reviews in the overview's row, each
      // opening the pop-up on its own review
      var gallery = root.querySelector('[data-nextdev-reviews-gallery]');
      if (gallery) {
        gallery.textContent = '';
        // the videos first here too, then the photos, each in the reviews' order
        var everything = [];
        customers.concat(cards).forEach(function (card) { everything = everything.concat(mediaOf(card)); });
        everything.sort(function (a, b) {
          return (b.hasAttribute('data-nextdev-reviews-video') ? 1 : 0) - (a.hasAttribute('data-nextdev-reviews-video') ? 1 : 0);
        });
        everything.forEach(function (button) {
          var picture = button.querySelector('.nextdev--reviews__photo');
          if (!picture) return;
          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'nextdev--reviews__overview-thumb';
          thumb.setAttribute('aria-label', button.getAttribute('aria-label') || 'Open the photo');
          var copy = picture.cloneNode(false);
          copy.removeAttribute('class');
          if (copy.tagName === 'IMG') copy.alt = '';
          else copy.muted = true;
          thumb.appendChild(copy);
          var mark = button.querySelector('.nextdev--reviews__play');
          if (mark) thumb.appendChild(mark.cloneNode(true));
          thumb.addEventListener('click', function () { openLightbox(button, thumb); });
          gallery.appendChild(thumb);
        });
        gallery.hidden = !gallery.firstChild;
        var galleryBox = root.querySelector('[data-nextdev-reviews-gallery-box]');
        if (galleryBox) galleryBox.hidden = gallery.hidden;
      }

      if (closeButton) closeButton.addEventListener('click', closeLightbox);
      if (prevReview) prevReview.addEventListener('click', function () { toReview(reviewAt - 1); });
      if (nextReview) nextReview.addEventListener('click', function () { toReview(reviewAt + 1); });
      if (prevMedia) prevMedia.addEventListener('click', function () { stepMedia(-1); });
      if (nextMedia) nextMedia.addEventListener('click', function () { stepMedia(1); });
      if (watch) watch.addEventListener('click', toggle);
      if (mute) mute.addEventListener('click', function () {
        if (!player) return;
        withSound = player.muted;
        player.muted = !withSound;
        markMute();
        // the tap counts as a gesture, so a video the browser held back starts
        if (player.paused) play();
      });

      // the ground around the panel closes it, and a review either side
      // moves to it
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) { closeLightbox(); return; }
        var ghost = event.target.closest && event.target.closest('.nextdev--reviews__lightbox-panel--ghost');
        if (ghost && Math.abs(ghost.nextdevReviewsPos) === 1) toReview(reviewAt + ghost.nextdevReviewsPos);
      });

      // a swipe across the pop-up moves to the review before or after
      var touchX = null;
      var touchY = null;
      lightbox.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) { touchX = null; return; }
        touchX = event.touches[0].clientX;
        touchY = event.touches[0].clientY;
      }, { passive: true });
      lightbox.addEventListener('touchend', function (event) {
        if (touchX === null || reviews.length < 2) return;
        var dx = event.changedTouches[0].clientX - touchX;
        var dy = event.changedTouches[0].clientY - touchY;
        touchX = null;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        toReview(reviewAt + (dx < 0 ? 1 : -1));
      });

      // heard on the page, so a key still answers once the focus has moved
      document.addEventListener('keydown', function (event) {
        if (lightbox.hidden) return;
        if (event.key === 'Escape') { closeLightbox(); return; }
        if (event.key === 'ArrowLeft') { event.preventDefault(); stepAll(-1); return; }
        if (event.key === 'ArrowRight') { event.preventDefault(); stepAll(1); return; }
        if (event.key !== 'Tab') return;

        // the tab order stays inside the pop-up while it is open
        var stops = Array.prototype.slice.call(lightbox.querySelectorAll(
          'button:not([hidden]):not([disabled])')).filter(function (stop) { return !stop.closest('[inert]'); });
        if (!stops.length) return;
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    render();
  }

  function start() {
    document.querySelectorAll('[data-nextdev-reviews]').forEach(setup);
  }

  start();
  document.addEventListener('shopify:section:load', start);
})();

// ---- how long ago, and was it helpful ----
// The date is written in the markup as a date, so a page with no script
// still says when; the script turns it into "3 days ago". A vote is this
// visitor's own, kept in the browser, and it moves the count by one: there
// is no server behind it, so nobody else sees it.
(function () {
  var KEY = 'nextdev-reviews-votes';
  var DAY = 864e5;

  function ago(iso) {
    var parts = iso.split('-');
    var then = new Date(+parts[0], parts[1] - 1, +parts[2]);
    var now = new Date();
    now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var days = Math.round((now - then) / DAY);
    function say(n, unit) { return n + ' ' + unit + (n === 1 ? '' : 's') + ' ago'; }
    if (days < 1) return 'Today';
    // days for the whole first month ("16 days ago" rather than "2 weeks
    // ago"), then months
    if (days <= 30) return say(days, 'day');
    if (days < 365) return say(Math.max(1, Math.floor(days / 30)), 'month');
    return say(Math.floor(days / 365), 'year');
  }

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }

  function write(votes) {
    try { localStorage.setItem(KEY, JSON.stringify(votes)); } catch (e) {}
  }

  // every copy of one review's vote, the card's and the pop-up's
  function paint(id, votes) {
    document.querySelectorAll('[data-nextdev-reviews-helpful="' + id + '"]').forEach(function (box) {
      box.querySelectorAll('[data-nextdev-reviews-vote]').forEach(function (button) {
        var way = button.getAttribute('data-nextdev-reviews-vote');
        var mine = votes[id] === way;
        var count = (parseInt(button.getAttribute('data-nextdev-reviews-votes'), 10) || 0) + (mine ? 1 : 0);
        var shown = button.querySelector('[data-nextdev-reviews-vote-count]');
        if (shown) shown.textContent = count;
        button.setAttribute('aria-pressed', mine ? 'true' : 'false');
        button.setAttribute('aria-label', (way === 'up' ? 'Yes, helpful, ' : 'No, not helpful, ') + count);
      });
    });
  }

  function start() {
    document.querySelectorAll('[data-nextdev-reviews-date]').forEach(function (time) {
      var iso = time.getAttribute('datetime');
      if (!iso || time.dataset.nextdevReviewsDated) return;
      time.dataset.nextdevReviewsDated = '1';
      time.title = time.textContent;
      time.textContent = ago(iso);
    });
    var votes = read();
    document.querySelectorAll('[data-nextdev-reviews-helpful]').forEach(function (box) {
      paint(box.getAttribute('data-nextdev-reviews-helpful'), votes);
    });
  }

  // one listener for the page, so the pop-up's copy answers as well
  if (!window.nextdevReviewsVotes) {
    window.nextdevReviewsVotes = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-nextdev-reviews-vote]');
      if (!button) return;
      var box = button.closest('[data-nextdev-reviews-helpful]');
      if (!box) return;
      var id = box.getAttribute('data-nextdev-reviews-helpful');
      var way = button.getAttribute('data-nextdev-reviews-vote');
      var votes = read();
      if (votes[id] === way) delete votes[id];
      else votes[id] = way;
      write(votes);
      paint(id, votes);
    });
  }

  start();
  document.addEventListener('shopify:section:load', start);
})();

// While a test shows the reviews section in place of Stamped's, the stars
// at the top of the page bring the visitor to it instead of to a widget
// that is hidden. With Stamped's widget on show they are left alone.
(function () {
  if (window.nextdevReviewsBadge) return;
  window.nextdevReviewsBadge = true;
  document.addEventListener('click', function (event) {
    var badge = event.target.closest && event.target.closest('.stamped-main-badge, .stamped-product-reviews-badge');
    if (!badge) return;
    var stamped = document.getElementById('stamped-main-widget');
    if (stamped && stamped.getClientRects().length) return;
    var ours = Array.prototype.find.call(document.querySelectorAll('[data-nextdev-reviews]'), function (each) {
      return each.getClientRects().length;
    });
    if (!ours) return;
    event.preventDefault();
    event.stopPropagation();
    ours.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
})();
